export default __webpack_public_path__ + "static/media/91.5850fd8b.jpeg";